var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 36 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v24H0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0v9h15v6H21v9h-6v-9H0V9h15V0z",
    fill: "#e8112d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9 14 1-1h7v7l-1 1h4l-1-1v-7h7l1 1v-4l-1 1h-7V4l1-1h-4l1 1v7h-7l-1-1z",
    fill: "#f9dd16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/gg.4ad7b0edec8846860bf948d53752e74e.svg";
export { ForwardRef as ReactComponent };